<template>
  <div class="skill-page">
    <!-- <div class="page-header">
      <h2>坐标转换</h2>
      <p>支持WGS84、GCJ02、BD09坐标系之间的相互转换</p>
    </div> -->

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard 
          title="坐标系转换工具" 
          description="支持GPS(WGS84)、高德/腾讯(GCJ02)、百度(BD09)三种坐标系相互转换，自动识别并清理坐标格式"
          :codeContent="transformCode">
          <CoordTransform />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import CoordTransform from '@/components/map/CoordTransform.vue'

export default {
  name: 'CoordTransformPage',
  components: {
    CodeCard,
    CoordTransform
  },
  data() {
    return {
      transformCode: `<template>
  <div class="coord-transform">
    <!-- 坐标系选择 -->
    <el-select v-model="fromCoord">
      <el-option label="WGS84 (GPS)" value="wgs84" />
      <el-option label="GCJ02 (高德)" value="gcj02" />
      <el-option label="BD09 (百度)" value="bd09" />
    </el-select>
    <span>转换到</span>
    <el-select v-model="toCoord">
      <el-option label="WGS84 (GPS)" value="wgs84" />
      <el-option label="GCJ02 (高德)" value="gcj02" />
      <el-option label="BD09 (百度)" value="bd09" />
    </el-select>
    
    <!-- 坐标输入输出 -->
    <el-input v-model="inputCoord" placeholder="经度,纬度" />
    <el-input v-model="outputCoord" readonly />
    <el-button @click="copyResult">复制</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    // 自动清理坐标格式
    cleanCoordString(str) {
      return str.replace(/['"]/g, '').trim().replace(/\\s+/g, '');
    },
    
    // WGS84 转 GCJ02
    wgs84ToGcj02(lng, lat) {
      // 转换算法实现...
    },
    
    // 其他转换方法...
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
.skill-page {
  /* 覆盖全局 .skill-page：撑满内容区，内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
  background-color: transparent;
}
.page-header {
  margin-bottom: 30px;
  text-align: center;
}
.page-header h2 {
  color: #303133;
  margin-bottom: 10px;
}
.page-header p {
  color: #606266;
  font-size: 14px;
}
</style>
